import { Group } from "../group/group";

export class Role {
  // from the backend side roles currently do not have an id
  // but in the frontend we´re building everyting like dropdowns
  // around the id, so we´re adding it here and set id = name
  id: string | undefined;
  label: string | undefined;
  name: string| undefined;
  isInherited: boolean | undefined;
  inheritedFrom: [Group];

  constructor(payload?: any) {
    if (payload) {
      this.label = payload.label;
      this.name = payload.name;
      this.id = payload.name; // see comment above
      this.isInherited = payload.isInherited;
      if(payload.inheritedFrom) {
        this.inheritedFrom = payload.inheritedFrom.map((group: any) => new Group(group));
      }
    }
  }

  /**
   * creates roles from a result
   * @param result Array of any
   * @returns Array of Role
   */
   static createRoles(result: Array<any>): Role[] {
    const roles = new Array<Role>();
    if (result) {
      result.map((role) => {
        roles.push(new Role(role));
      });
    }
    return roles;
  }
}
